export default __webpack_public_path__ + "static/showcaseMotionMobile-f3228a3caad803ff453b4759d8312e35.mp4";